/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";

export async function registerDealer(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealers/register`, {
    method: "POST",
    data: params,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function createNewDealer(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealers`, {
    method: "POST",
    data: params,
  });

  return result?.data;
}

export async function updateDealer(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealers/${params.id}`, {
    method: "PUT",
    data: params,
  });

  return result?.data;
}

export async function getAllDealers({
  filter = "",
  autosledManager,
  name,
  city,
  flagStatus,
  stateId,
  sorting,
  page = 1,
  pageSize = 10,
  hasGroup,
}) {
  page--;

  const SkipCount = page * pageSize;
  let Sorting;

  if (typeof sorting === "string" && sorting.indexOf(":") !== -1) {
    const [sortBy, sortOrder] = sorting.split(":");
    Sorting = `${sortBy} ${sortOrder}`;
  }

  const params = {
    FilterText: filter || undefined,
    ManagerId: autosledManager,
    City: city,
    Status: flagStatus,
    StateId: stateId,
    Name: name,

    Sorting,
    SkipCount,
    MaxResultCount: pageSize,
  };

  if (hasGroup !== undefined) {
    params.HasGroup = hasGroup;
  }

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealers`, {
    method: "GET",
    params,
  });

  return result?.data;
}

export async function getDealerById(dealerId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealers/${dealerId}`, {
    method: "GET",
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function updateStatus(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company/${params.id}/status`, {
    method: "PUT",
    data: params.data,
  });

  return result?.data;
}

export async function updateDealerManager(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealers/update-manager/${params.id}`, {
    method: "PATCH",
    params: {
      managerId: params.managerId,
    },
  });

  return result?.data;
}

export async function getDealersAllowed({
  filter = "",
  autosledManager,
  name,
  city,
  flagStatus,
  stateId,
  page = 1,
  pageSize = 10,
}) {
  page--;

  const SkipCount = page * pageSize;

  const params = {
    FilterText: filter || undefined,
    ManagerId: autosledManager,
    City: city,
    Status: flagStatus,
    StateId: stateId,
    Name: name,

    SkipCount,
    MaxResultCount: pageSize,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealers/allowed`, {
    method: "GET",
    params,
  });

  return result?.data;
}

export async function getDealerAllowedById(dealerId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealers/allowed/${dealerId}`, {
    method: "GET",
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function requestDealerInfoChange(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealers/request-info-change`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result;
}
